











































































































































































































































































































	import { Component, Vue } from 'vue-property-decorator'
	import * as Bubbles from '@/assets/scripts/BubblesModule'

	@Component
	export default class Home extends Vue {
        mounted() {
			new Bubbles.BubblesModule();
		}
    }
